import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { TextInputDecorator } from '../TextInputDecorator/TextInputDecorator';

import './SearchInputWithSuggest.css';

export interface SearchInputWithSuggestProps {
    cls?: string;
    placeholder?: string;
    text?: string;
    onChange: (value: string) => void;
    onItemSelect?: (elementProps: {}) => void;
    noItemsRender?: () => JSX.Element;
}

export interface SearchInputWithSuggestState {
    text: string;
}

export class SearchInputWithSuggest extends React.Component<SearchInputWithSuggestProps, SearchInputWithSuggestState> {
    private block = 'search-input';
    private hasCalled = false;
    private prevTimer?: NodeJS.Timer;

    constructor(props: SearchInputWithSuggestProps) {
        super(props);

        this.state = {
            text: props.text || ''
        };
    }

    render() {
        return (
            <TextInputDecorator
                theme="normal"
                size="n"
                pin="round-round"
                cls={classNames(this.props.cls, Bem.cls(this.block, 'input'))}
                placeholder={this.props.placeholder}
                hasClear={true}
                text={this.state.text}
                onChange={this.onChange}
                iconLeft={<Shape2 width={20} height={20} icon={Shape2Icon.mapPin} />}
            />
        );
    }

    private onChange = (text: string) => {
        this.setState({ text });

        if (this.hasCalled && this.prevTimer) {
            clearTimeout(this.prevTimer);
        }

        this.prevTimer = setTimeout(() => {
            this.props.onChange(text);
            this.hasCalled = false;
        }, 500);
        this.hasCalled = true;
    };
}
